module.exports = __webpack_public_path__ + "static/media/taylor-momsen-icon.86d16577.jpg";